export default {
  message: {
    // Welcome Landing messages
    welcome: 'Welcome to TD Complete!',
    welcomeMessage:
      'Welcome to the TD Complete Enrollment Portal. With this application, you are applying to offer financing to your in-store customers.  Approved businesses are able to offer their in-store customers retail financing through the TD Complete ' +
      'financing program. To begin your application, please click <b>START NOW</b>.',
    welcomeMessageAdmin:
      'Welcome to the TD Complete Enrollment Portal. There are currently no working applications to review.',
    updateAppInvalidateWarning:
      'Are you sure you want to update this application? Any e-signatures will be cleared and owners will be notified by email. This application is set to expire {expireDate}',
    // Login Messages
    login: {
      error: {
        unauthorized:
          'You are currently unauthorized to view this page. Please try logging in to view page',
        generic:
          'There has been an error accessing the page you have requested. Please try again'
      },
      login: 'Login',
      register: 'Register',
      welcome: 'Welcome to TD Complete!',
      welcomeMessage:
        'Welcome to the TD Complete Enrollment Portal. Enter your email address and password then click LOGIN or click REGISTER to create a new account.',
      emailSent: 'Your access link has been sent!',
      emailMessage:
        'A one-time access link has been sent to <b><u>{email}</u></b>. Please click on this link start or resume your application.',
      resendMessage:
        "Didn't receive an email? Please check your spam folder or click <b>RE-SEND</b> below to verify your email address and re-send your access link."
    },

    verifyAccount: {
      verifyAccount: 'Verify Account',
      welcome: 'Welcome to TD Complete!',
      welcomeMessage1:
        'Thank you for verifying your account. Please create a unique password in the fields below and click CREATE PASSWORD to get started.'
    },

    dealerApp: {
      comment: 'Comment'
    },

    passwordReset: {
      passwordReset: 'Request Reset',
      welcome: 'Password Reset',
      welcomeMessage:
        'Enter your email and click <b>REQUEST RESET</b> to request a password reset.'
    },

    // Register Messages
    register: {
      register: 'Register',
      welcome: 'Welcome to TD Complete!',
      welcomeMessage: {
        tdcomplete:
          'In order to apply for the TD Complete Enrollment Portal, you must first enter your email address and click REGISTER. You will receive an email to complete your account set up. If you have already started your application, please click Login.'
      },
      emailSent: 'Your account setup email has been sent!',
      emailMessage:
        'An email has been sent to <b><u>{email}</u></b>. Please click on the link to create your account.',
      resendMessage:
        "Didn't receive an email? Please check your spam folder or click <b>RE-SEND</b> below to verify your email address and re-send the email."
    },

    entityDocTypes: {
      articleOfIncorporation:
        'Articles of Incorporation/Organization (filed with the state) OR Certificate of Good Standing (issued by state or county) OR State website report.',
      fictitiousName:
        'Fictitious Name Certificate (if applicable by state, county, or local registrar)',
      boardOfDirectors:
        "Board of Director's Resolution/By-Laws (if applicable)",
      operatingAgreement: 'Operating Agreement (if applicable)',
      partnershipAgreement: 'Partnership Banking Agreement (if applicable)',
      solePropSsn:
        "No formal business. Using the owner's SSN (This account type is used for a business with one owner and the business does not have a TIN ) Sample Account Title: Sam Mendez. No documentation need. ",
      solePropJointDBA:
        "Joint DBA. Using the owner's SSN (This account type is used for a business with more than one owner and the business does not have a TIN ) Sample Account Title: Sam Mendez or James Mendez DBA Mendez Construction.",
      solePropUsingTin:
        'Using a TIN. Sample Account Title: Mendez Construction. Documentation Required.'
    },

    // Generic Buttons / Form stuff
    add: 'Add',
    save: 'Save',
    resume: 'Resume',
    start: 'Get Started',
    submit: 'Submit',
    submitApplication: 'Submit Application',
    esignApplication: 'E-Sign Application',
    unlockApplication: 'Edit Business Enrollment Application',
    resend: 'Re-Send',
    reenter: 'Re-Enter Email',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    remove: 'Remove',
    home: 'Home',
    more: 'More',
    logout: 'Log Out',
    download: 'Download',
    upload: 'Upload',
    incCertificationUploaded: 'Document Uploaded',
    incCertificationRequired: 'Document Required For Application',
    // Yes / Np
    yes: 'yes',
    no: 'no',
    requiredLabel: '*indicates required field',

    // Application List
    applicationList: 'Application List',
    application: '{0} Application #{1}',
    startNewApplication: 'Start New Application',
    noApplications:
      'At this time you have not started any applications, to start a new application please click <b>Start Application</b>',
    appListHeaders: ['Program', 'Expiration Date'],
    dealerApplicationStatuses: {
      0: 'In Progress',
      1: 'Submitted',
      2: 'Signed Off',
      3: 'Underwritten'
    },
    lenderTierName: {
      'PRIME' : 'PRIME',
      'NEAR_PRIME' : 'NEAR-PRIME',
      'LEASE' : 'SUB-PRIME'
    },
    newApplication: 'New Application',
    finalizeDaysRemaining:
      'As a reminder, you have until {expirationDate} to complete this application.',
    appSubmitTerms:
      'To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial ' +
      'institutions to obtain, verify and record information that identifies each person who opens an account. ' +
      'What does this mean for you:  When you open an account, we will ask you for your name, address, date of birth, telephone number, social security number ' +
      "and other information that will allow us to identify you. We may also ask for your driver's license or other identifying documents.",

    // Application Messages
    dealerAppHeader: 'Dealer Application',
    dealerAppInfo:
      'Please complete all required information. After completing requirements on all application tabs, please review the application on the <b>FINALIZE</b> tab and submit for processing.',
    dealerAppInfoSubmitted: '',
    tabHeader: {
      applicant: 'Applicant',
      proofOfBusEntity: 'Proof of Business Entity',
      owners: 'Owners',
      storeLocations: 'Locations',
      achInfo: 'ACH Info',
      ownerInfo: 'Owner Info',
      finalize: 'Finalize',
      CollectFinancials: 'Collect Financials'
    },

    // keys must match server enum
    orgTypeVals: {
      CORPORATION: 'Corporation',
      S_CORPORATION: 'S. Corporation',
      PARTNERSHIP: 'Partnership',
      SOLE_PROPRIETOR: 'Sole Proprietorship',
      LLC: 'Limited Liability Corporation'
    },

    // keys must match server enum
    llcTypeVals: {
      SINGLE_MEMBER_LLC: 'Single-Member LLC',
      C_CORPORATION: 'C. Corporation',
      S_CORPORATION: 'S. Corporation',
      PARTNERSHIP: 'Partnership'
    },

    // keys must match server enum
    lenderStatusVals: {
      UNDER_REVIEW: 'Under Review',
      PENDING_SIGN_OFF: 'Pending Sign Off',
      APPROVED: 'Approved',
      APPROVED_NO_LOGIN: 'Approved - No Login',
      DECLINED: 'Declined',
      EXISTING: 'Existing',
      EXISTING_NO_LOGIN: 'Existing - No Login',
      UNAVAILABLE_PROVIDER_RESTRICTIONS: 'Unavailable (Provider Restrictions)',
      NOT_APPLICABLE: 'Not Applicable'
    },

    instructions: {
      applicant: 'Please complete all required fields and click <b>SAVE</b>.',
      dealerInfo: '',
      owners:
        'We must collect information on <span class="special-emphasis1">all</span> beneficial owners with at least 25% ownership to be compliant with the USA Patriot Act and CIP (Customer Identification Program) which requires us to determine the true identity of all applicants. This would include name, address, SSN and DOB for <span class="special-emphasis1">each</span> beneficial owner with 25%+ ownership. If there are no owners with at least 25% ownership, please contact Merchant Services at 1-800-538-3638. <br><br> <span class="special-emphasis2">Failure to provide the requested information on all owners with  25%+ ownership will result in application processing delays.</span>',
      references:
        'Please add bank and credit references for your organization. At least one Bank Reference must be included.',
      storeLocations:
        'If you have multiple locations in addition to your primary location listed on the dealer application, please list your additional locations below. Please only add locations that will be offering financing. Note that additional locations must share the same TIN as the primary location.',
      lenderSelection: 'Please select the desired lenders',
      incCertificationUpload1:
        'Please upload a valid business document as a proof of business entity and a document verifying your Federal Tax Identification Number. Click ',
      incCertificationUpload2:
        " to see examples of valid business documents based on legal formation. Examples of TIN verification documents include: SS-4 confirmation from the IRS or First page of current year's audited financials.",
      incCertificationUpload: {
        note: {
          anow:
            'Note: To apply with AcceptanceNow you are required to provide your W-9. If you are unable to upload your W-9 at this time, you will be contacted by AcceptanceNow to provide this document prior to being approved for their services.'
        }
      },
      ownerInfo:
        'Please provide the information requested below for identification and verification purposes.',
      achInfo:
        'Click ACH INFO below to complete your Electronic Funds Transfer Application and upload a copy of a voided check.',

      achLegal1: 'By submitting this Electronic Funds Transfer Application I ',
      achLegal2:
        ' (Officer), on behalf of <b>{0}</b> (Company),' +
        ' for purposes of settlement, authorize all credit and/or lease providers selected by Company in this application (each a Provider), to automatically deposit/debit,' +
        " Company's net settlement and payment into each account as specified below. This authority will remain in effect for each Provider, until said Provider receives" +
        ' written notification of its revocation and has had reasonable time to act on it.',

      achFileUpload:
        'Please upload a voided check or deposit slip for the account to which credit/debit will be made.',
      finalize: 'Please review and confirm all information is correct.',
      finalizeSubmitted: 'The application has been submitted and is now locked.'
    },
    updateAuthorizingOfficer: 'Update authorizing officer',
    saveAndResume:
      'You may save and resume as needed during the application open period',
    proofOfBusEntity: 'Proof of Business Entity',
    lenderSelection: 'Lender Selection',
    dealerName: 'Legal Business Name',
    dba: 'd/b/a',
    taxID: 'Federal Tax Identification Number',
    organizationType: 'Organization Type',
    llcType: 'LLC Classification',
    yearsBusiness: 'Years in Business',
    monthsBusiness: 'Months in Business',
    numLocations: 'No. Locations',
    dealerAddress: 'Principal Business Address',
    storeIpAddress: 'Store IP Address',
    streetAddress: 'Street Address',
    homeAddress: 'Home Address',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    email: 'Email Address',
    phoneNumber: 'Phone Number',
    businessPhoneNumber: 'Business Phone Number',
    bankPhoneNumber: 'Bank Phone Number',
    faxNumber: 'Fax Number',
    typeOfBusiness: 'Type of Business',
    dealerWebsite: 'Website',
    lastUpdateDate: 'Last Saved',
    questions: {
      website: 'Do you have a business website?',
      tdMerchantNumber: 'Are you currently an Active Dealer with TD Retail Card Services? If yes: Please provide your 6-digit TD Merchant Number.',
      avbHostedWebsite: 'Is your website hosted by AVB?',
      offerApplyAndBuy: 'Do you plan to offer Apply & Buy Online through the AVB website?',
      wantOnlineCreditAppLink: 'If your website is not hosted by AVB, would you like a link to an online credit application that can be placed on your website?'
    },
    tdMerchantNumber: "TD Merchant Number",
    annualSalesAmount: 'Estimated Overall Annual Sales',
    annualFinancingAmount: 'Estimated Overall Annual Financing ',
    avgTicketAmount: 'Estimated Average Financed Ticket',
    explain: 'Please Explain',
    numberOfLocations: 'Number Of Store Locations',
    avbMarketingId: 'AVB Marketing Id',
    fileType: 'Document Type',
    selectFile: 'Select File',

    // Co-Owners
    newOwner: 'New Owner',
    updateOwner: 'Update Owner',
    noOwner: 'Please click <b>ADD</b> to add an owner',
    ownerLabel: 'Owner',
    owner: {
      name: 'Full Name',
      title: 'Job Title',
      percentageOwned: '% Owned',
      ssn: 'SSN',
      dateOfBirth: 'Date Of Birth'
    },
    next: 'Next',
    previous: 'Previous',

    // Bank References
    newReference: 'New Reference',
    noReference: 'Please click <b>ADD</b> to add a reference',
    creditReference: 'Credit Reference',
    bankReference: 'Bank Reference',
    referenceTypeVals: {
      BANK: 'Bank',
      CREDIT: 'Credit'
    },
    reference: {
      name: 'Name',
      type: 'Type',
      accountNumber: 'Account Number',
      loanOfficer: 'Loan Officer',
      productFinanced: 'Product Financed'
    },

    // Store Locations
    newLocation: 'New Location',
    updateLocation: 'Update Location',
    noLocation: 'Please click <b>ADD</b> to add a store location',
    locationLabel: 'Location',
    location: {
      name: 'Name/DBA',
      contactName: 'Contact Full Name'
    },

    import: {
      label: 'Import',
      locations: 'Import Locations',
      step1: 'Download the template file here. ',
      step2:
        'Fill it out with your store location data using the sample row as a format guide, leaving the column headers untouched.  All columns are required except Fax and Email.',
      step3: 'Upload it here. '
    },

    // ACH Info
    achInfo: 'ACH Info',
    newAchInfo: 'New ACH Info',
    updateAchInfo: 'Update ACH Info',
    ach: {
      merchantNumber: 'Merchant #',
      bankName: 'Bank Name',
      bankAddress: 'Bank Address',
      contactName: 'Bank Contact Full Name',
      routingNumber: 'Routing Number',
      accountNumber: 'Account Number',
      documentRequired: 'Document Required For ACH Enrollment',
      officer: 'Officer'
    },

    // Articles of incorporation Info
    incArticles: 'Inc Articles',
    newincArticles: 'New Inc Articles',
    updateincArticles: 'Update Inc Articles',

    // Finalize Application
    finalize: {
      noIncArticle:
        'This application does not have any Articles of Incorporation, Please go to <b>INC. ARTICLES</b> tab and add at least one',
      noOwner:
        'This application does not have any owners, Please go to <b>OWNERS</b> tab and add at least one',
      noReference:
        'This application does not have any reference, Please go to <b>REFERENCES</b> tab and add at least one bank reference',
      noLocation:
        'This application does not have any additional store locations'
    },

    dealerTermsPleaseClick:
      'Please click the following link to view the Dealer Agreement',
    dealerTermsThanksClick: 'Thank you for viewing the Dealer Agreement',

    achTermsPleaseClick:
      'ACH Terms and Conditions are available at the following link:',

    fullName: 'Full Name',

    // Alerts
    alert: {
      save: {
        success: 'Your Application was saved successfully',
        error: 'There was an error saving your application'
      }
    },

    // Contact US Page
    contact: {
      header: 'Contact Us',
      message:
        'If you are having any issues with your application or the application process, please contact Support at:'
    },
    supportNumberMsg: ""
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/lang/tdcomplete_en.js